import React from 'react';
import TermsRender from "./TermsRender";
import {Term} from "./interfaces";

interface TermGroupProps {
  term: Term
}

const TermGroup: TermGroupComponent = ({term}) => {

  const TermChildren: Function = (): JSX.Element => {
    return <TermsRender terms={term.items} />
  }

  return (
    <div className={'group'}>
      <div style={{ borderBottom: "1px solid black", paddingBottom: 2, marginBottom: 5}}>{term.title}</div>
      <TermChildren />
    </div>
  )
}

export type TermGroupComponent = (props: TermGroupProps) => JSX.Element;

export default TermGroup;
